/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderTagWithNetSales } from './OrderTagWithNetSales';
import {
    OrderTagWithNetSalesFromJSON,
    OrderTagWithNetSalesFromJSONTyped,
    OrderTagWithNetSalesToJSON,
    OrderTagWithNetSalesToJSONTyped,
} from './OrderTagWithNetSales';

/**
 * 
 * @export
 * @interface MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponse
 */
export interface MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponse {
    /**
     * 
     * @type {Array<OrderTagWithNetSales>}
     * @memberof MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponse
     */
    data: Array<OrderTagWithNetSales>;
}

/**
 * Check if a given object implements the MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponse interface.
 */
export function instanceOfMenuMixBusinessProductCategoryOrderTagsWithNetSalesResponse(value: object): value is MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponseFromJSON(json: any): MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponse {
    return MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponseFromJSONTyped(json, false);
}

export function MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(OrderTagWithNetSalesFromJSON)),
    };
}

export function MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponseToJSON(json: any): MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponse {
    return MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponseToJSONTyped(json, false);
}

export function MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponseToJSONTyped(value?: MenuMixBusinessProductCategoryOrderTagsWithNetSalesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(OrderTagWithNetSalesToJSON)),
    };
}

